
namespace TabAurous.Common {
    import fld = Stock.StockItemRow.Fields;
   
    @Serenity.Decorators.registerClass()
    export class WorkOrderStockJWSelectGrid extends _Ext.GridBase<Production.WorkOrderItemsRow, any> {

        protected getColumnsKey() { return 'Production.WorkOrderItems'; }
        protected getDialogType() { return <any>Production.WorkOrderItemsDialog; }
        protected getIdProperty() { return Production.WorkOrderItemsRow.idProperty; }
        protected getLocalTextPrefix() { return Production.WorkOrderItemsRow.localTextPrefix; }
        protected getService() { return Production.WorkOrderforJWService.baseUrl; } 
 

        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            return this;
        }
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()
        }
        get selectedItems(): Production.WorkOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;

            return true;
        }
    } 
}